export enum Retrognathism {
    normale_beet = 'Normale beet, maar boventanden komen iets over de ondertanden heen',
    onbekend = 'Onbekend',
    onderbeet = 'Onderbeet, onderkaak ligt meer naar voren dan normaal',
    overbeet = 'Overbeet, onderkaak ligt meer naar achteren dan normaal',
}
